import {
  differenceInMinutes,
  differenceInMonths,
  setDate,
  setHours,
  setMinutes,
  setMonth
} from 'date-fns';
import type { ScheduleSolversDisplayConfigType } from '../../types';
import { getDateFromControlValue } from '../../utils/get-date-obj';

export const sameDayInMonth = ({
  freq = 1,
  endDate,
  startDate,
  userDate,
  scheduleRepeatEnds,
  scheduleRepeatEndsDate,
  scheduleRepeatEndsOccurrences
}: ScheduleSolversDisplayConfigType) => {
  const viewDurationInMinutes = differenceInMinutes(endDate, startDate);
  const viewDurationInMonths = differenceInMonths(endDate, startDate);

  const monthPassedFromStart = differenceInMonths(userDate, startDate);

  const startHour = startDate.getHours();
  const startMinutes = startDate.getMinutes();

  const day = startDate.getDate();

  const startDateInThisMonth = setMinutes(
    setHours(setDate(userDate, day), startHour),
    startMinutes
  );
  const endDateInThisMonth = new Date(
    startDateInThisMonth.getTime() + viewDurationInMinutes * 60 * 1000
  );

  if (
    scheduleRepeatEnds === 'onDate' &&
    userDate.getTime() >=
      getDateFromControlValue(scheduleRepeatEndsDate).getTime()
  ) {
    return false;
  }

  if (scheduleRepeatEnds === 'afterOccurrences') {
    const endRepeatMonthDate = setMonth(
      startDate,
      startDate.getMonth() + freq * Number(scheduleRepeatEndsOccurrences)
    );

    const startDateInThisMonth = setMinutes(
      setHours(setDate(endRepeatMonthDate, day), startHour),
      startMinutes
    );

    if (userDate.getTime() >= startDateInThisMonth.getTime()) {
      return false;
    }
  }

  return (
    userDate.getTime() >= startDate.getTime() &&
    userDate.getTime() >= startDateInThisMonth.getTime() &&
    userDate.getTime() <= endDateInThisMonth.getTime() &&
    monthPassedFromStart % freq <= viewDurationInMonths
  );
};
